import axios from '../../axios';

export default {
	state: {},
	getters: {},
	mutations: {},
	actions: {
		async searchForIntercomTicket(context, { orderId }) {
			const url = `/intercom/search/` + orderId;
			await axios.post(url);
		},
		async syncIntercomTicket(context, { orderId }) {
			const url = `/intercom/sync/` + orderId;
			await axios.post(url);
		}
	}
}
